module.exports = __webpack_public_path__ + "static/media/tuition_info.aac61876.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/tuition_info.png
// module id = 252
// module chunks = 0